import React from "react";
import {
  FormControlLabel,
  Popper,
  Paper,
  ClickAwayListener,
} from "@material-ui/core";
import { useState } from "react";
import StyledCheckbox from "./StyledCheckbox";
import ChevronDownIcon from "../icons/ChevronDownIcon";

/**
 * A select component that opens a popover with checkbox options. Used in table filter bars
 *
 * @component
 * @param {Object} props
 * @param {string} props.currentFilter - The key for the current filter in the filters object
 * @param {string} props.title - The text to display on the select button
 * @param {Function} props.setFilter - Callback function to update the filter state
 * @param {Object} props.filters - Object containing all current filter states
 * @param {Array} props.options - Array of options to display in the popover [{label: string, value: any}]
 * @param {boolean} [props.compact=false] - If true, uses more compact styling with smaller text
 * @param {('default'|'student')} [props.variant='default'] - The style variant to use when compact size is set to true:
 *   - 'default': Standard styling with grey background for blue filter bar components
 *   - 'student': White text and white background for white filter bar components on the students and incidents pages
 * @returns {React.ReactElement}
 */

const PopoverSelect = ({
  currentFilter,
  title,
  setFilter,
  filters,
  options,
  compact = false,
  variant = "default",
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (option) => {
    const newFilter =
      filters[currentFilter]?.value === option.value ? null : option;
    setFilter({ ...filters, [currentFilter]: newFilter });
  };

  const open = Boolean(anchorEl);

  const hasSelected = filters?.[currentFilter] !== null;

  return (
    <div>
      <button
        className={`flex items-center gap-8 md:text-16 border !border-transparent rounded-md  p-4 ${
          compact
            ? `!text-14 ${variant === "student" ? "text-white" : "text-[#374151]"} font-medium`
            : "text-16"
        }`}
        onClick={handleClick}
        type="button"
      >
        {title}
        {hasSelected ? (
          <span
            className={`text-10 text-black rounded  h-16 w-16 flex items-center justify-center ${
              variant === "student" ? "bg-white" : "bg-grey-300"
            }`}
          >
            1
          </span>
        ) : (
          ""
        )}{" "}
        <ChevronDownIcon className="w-10" />
      </button>
      <Popper
        anchorEl={anchorEl}
        open={open}
        placement="bottom"
        modifiers={{
          offset: {
            enabled: true,
            offset: "0,8",
          },
        }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3}>
            <div className="flex flex-col gap-4  my-0 p-8 border border-grey-200 rounded min-w-[200px]">
              {options?.map((option) => (
                <FormControlLabel
                  className="gap-8 px-8  mx-0 hover:bg-grey-200 rounded-md w-full"
                  control={
                    <StyledCheckbox
                      checked={filters?.[currentFilter]?.value === option.value}
                      color="primary"
                      disableRipple
                      onChange={() => handleCheckboxChange(option)}
                    />
                  }
                  key={option.value}
                  label={option.label}
                  labelPlacement="end"
                />
              ))}
            </div>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default PopoverSelect;
